import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import merge from 'lodash/merge'

import { IconProps } from './Icon.types'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
// import {
//     faCheckSquare,
//     faWindowClose,
//     faTimes,
//     faHouseUser,
//     faUser,
//     faUsers,
//     faSun,
//     faChevronLeft,
//     faChevronRight,
//     faChevronUp,
//     faChevronDown,
//     faTasks,
//     faSpinner,
//     faExclamationCircle,
//     faFileInvoiceDollar,
//     faCreditCard,
//     faFileSignature,
//     faBolt,
//     faCog,
//     faSatelliteDish,
//     faRetweet,
//     faChartLine,
//     faCalendarAlt,
//     faSearch,
//     faArrowRight,
//     faArrowLeft,
//     faArrowDown,
//     faArrowUp,
//     faCheckCircle,
//     faBan,
//     faFlag,
//     faTimesCircle,
//     faEdit,
//     faList,
//     faHistory,
//     faArrowsAlt,
//     faTrash,
//     faTrashAlt,
//     faMinusCircle,
//     faPlusCircle,
//     faPlus,
//     faFilter,
//     faExpand,
//     faCompress,
//     faEnvelope,
//     faEnvelopeSquare,
//     faEnvelopeOpen,
//     faPhone,
//     faPhoneSquare,
//     faInfo,
//     faInfoCircle,
//   faMapMarker,
//
// } from '@fortawesome/free-solid-svg-icons'

import * as Icons from '@fortawesome/free-solid-svg-icons'
const iconList = Object.keys(Icons)
    .filter((key) => key !== 'fas' && key !== 'prefix')
    .map((icon) => Icons[icon])

library.add(...iconList)
// library.add(icons)
//
// library.add(
//     fab,
//     faChevronLeft,
//     faChevronRight,
//     faChevronUp,
//     faChevronDown,
//     faCheckSquare,
//     faWindowClose,
//     faTimes,
//     faHouseUser,
//     faUser,
//     faUsers,
//     faSun,
//     faTasks,
//     faSpinner,
//     faExclamationCircle,
//     faFileInvoiceDollar,
//     faCreditCard,
//     faFileSignature,
//     faBolt,
//     faCog,
//     faSatelliteDish,
//     faRetweet,
//     faChartLine,
//     faCalendarAlt,
//     faSearch,
//     faArrowRight,
//     faArrowLeft,
//     faArrowDown,
//     faArrowUp,
//     faCheckCircle,
//     faBan,
//     faFlag,
//     faTimesCircle,
//     faEdit,
//     faList,
//     faHistory,
//     faArrowsAlt,
//     faTrash,
//     faTrashAlt,
//     faMinusCircle,
//     faPlusCircle,
//     faPlus,
//     faFilter,
//     faExpand,
//     faCompress,
//     faEnvelope,
//     faEnvelopeSquare,
//     faEnvelopeOpen,
//     faPhone,
//     faPhoneSquare,
//     faInfo,
//     faInfoCircle,
// )

const Icon: React.FC<IconProps> = ({
    className = '',
    fontSize,
    spin = false,
    iconStyle,
    style,
    type,
    size = 'sm',
    light = false,
    width,
}) => {
    const _style = merge(
        {
            fontSize,
        },
        style,
    )

    const classNames = () => {
        const c = ['r-icon-container', className]

        if (spin) {
            c.push('r-icon-spin')
        }

        return c.join(' ')
    }

    return (
        <div style={_style} data-testid='Icon' className={classNames()}>
            <FontAwesomeIcon
                style={merge(
                    {
                        transition: '0.15s ease-in-out',
                    },
                    iconStyle,
                )}
                icon={type}
                spin={spin}
            />

            {/*<img alt={'ICON_' + type} src={getIcon()} width={getWidth()} />*/}
        </div>
    )
}

export default Icon
